<template>
  <div
    class="
      flex-shrink-0
      z-10
      sticky
      h-16
      bg-white
      shadow
      px-6
      flex
      items-center
      justify-between
    "
  >
    <div class="flex items-center">
      <BackButtonHeader />
      <TheBreadcrumb />
    </div>
    <div>
      <AccountDropdownMenu />
    </div>
  </div>
</template>

<script>
import BackButtonHeader from '@/components/BackButtonHeader'
import TheBreadcrumb from '@/components/TheBreadcrumb'
import AccountDropdownMenu from '@/components/AccountDropdownMenu'

export default {
  name: 'TheHeader',

  components: {
    BackButtonHeader,
    TheBreadcrumb,
    AccountDropdownMenu,
  },
}
</script>
